import { render, staticRenderFns } from "./ConfirmationDelivery.vue?vue&type=template&id=cd3c07b2&"
import script from "./ConfirmationDelivery.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports